import axios from "axios";
import { Message } from "element-ui";
import store from "../store";
import {getToken} from "./auth";

// 创建 axios 实例
const service = axios.create({
  baseURL: process.env.BASE_API,
  timeout: 15000
});

// request 拦截器
service.interceptors.request.use(config => {
  if (store.getters.token) {
    config.headers['Authorization'] = getToken();
  }
  return config;
}, error => {
  console.log(error);
  Promise.reject(error);
})

// response 拦截器
service.interceptors.response.use(

  response => {
  /**
   * code 非 200 即抛错
   */
  const result = response.data;
  if (result.code !== 200) {

    // 消息提示
    Message({
      message: result.message,
      type: 'error',
      duration: 3 * 1000,
    });

    // 返回错误
    return Promise.reject('error');
  }

  // 返回数据
  return response.data;
},

  error => {
    console.log('error' + error); // for debug

    // 消息提示
    Message({
      message: error.message,
      type: 'error',
      duration: 3 * 1000,
    });

    // 返回错误
    return Promise.reject(error);
  }
);

export default service;



// WEBPACK FOOTER //
// ./src/utils/request.js